import "../../stylesheets/App.css";
import "../../stylesheets/PopupRegister.css";
import "../../stylesheets/FinalOfTheGame.css";
import React from "react";
import { useNavigate } from "react-router-dom";

function FinalOfTheGame() {
  const navigate = useNavigate();

  return (
    <>
      <div className="popup-register-container final-game-container">
        <div className="popup">
          <div>
            <img
              src={process.env.PUBLIC_URL + "/images/login/banner-login.png"}
              style={{ maxWidth: "280px", margin: "0 auto" }}
            />
          </div>
          <h1>¡El juego ha terminado, gracias por participar!</h1>
          <h2>
            Para consultar la posición en el juego puedes dirigirte a la sección
            del ranking:
          </h2>
          <button className="btn lightgreen-btn" onClick={() => navigate("/ranking")}>
            Ranking
          </button>
        </div>
      </div>
    </>
  );
}

export default FinalOfTheGame;
